import styled from "styled-components";

export const STFormWrapper = styled.div`
  && {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 80px;
  }
`;
